export const commentsUnderThePostContainingKeywordsIncludedOptions = [
  {
    text: 'Yes',
    value: 'true',
  },
  {
    text: 'No',
    value: 'false',
  },
];
